<template>
  <div id="components">
    <Music :musicSrc="'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2246519039&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true'" />
  </div>
</template>

<script>

import Music from "@/components/Music";

export default {
  name: 'Music-View',
  components: {Music},
}
</script>
